/*
  import { boardDocumentCategoryStore } from '@/services/BoardDocumentCategory/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await escrowStore.dispatch ('getEscrowList', {
      hoaId
    });
  */

  async getBoardDocumentCategoryList({}, { hoaID }) {
    console.log('in getBoardDocumentCategoryList...' + hoaID)
    try {
      const results = await kms.get(`/BoardDocuments/BoardDocumentCategory/List?hoaID=${hoaID}`)

      if (isDebug == true)
        console.debug('getBoardDocumentCategoryList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The Board Document Category list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const boardDocumentCategoryStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
